import { render, staticRenderFns } from "./kvkk-policy.vue?vue&type=template&id=047c6590"
import script from "./kvkk-policy.vue?vue&type=script&lang=js"
export * from "./kvkk-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports